import { render } from "./CreateServiceAccount.vue?vue&type=template&id=31bbefbc&ts=true"
import script from "./CreateServiceAccount.vue?vue&type=script&lang=ts"
export * from "./CreateServiceAccount.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__